export const TABLE_PAGINATION_HEIGHT = 40
